"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon_button = _interopRequireDefault(require("./icon_button"));

var _notification_badge = _interopRequireDefault(require("./notification_badge"));

var _notification_center_item = _interopRequireDefault(require("./notification_center_item"));

var _app_bar_panel = _interopRequireDefault(require("./shared/app_bar_panel"));

require("../css/notification_center.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BellButton = function BellButton(_ref) {
  var active = _ref.active,
      onClick = _ref.onClick,
      unreadCount = _ref.unreadCount;
  return _react.default.createElement("div", {
    className: "vn-notification-center__bell-button"
  }, unreadCount === 0 && _react.default.createElement("div", {
    className: "vn-notification-center__bell-button-wrapper"
  }, _react.default.createElement(_icon_button.default, {
    active: active,
    icon: "notification",
    onClick: onClick
  })), unreadCount > 0 && _react.default.createElement(_notification_badge.default, {
    position: "top-left",
    value: unreadCount
  }, _react.default.createElement(_icon_button.default, {
    active: active,
    icon: "notification",
    onClick: onClick
  })));
};

BellButton.propTypes = {
  active: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  unreadCount: _propTypes.default.number
};
BellButton.defaultProps = {
  unreadCount: 0
};

var countUnreadNotifications = function countUnreadNotifications(children) {
  if (children) {
    return _react.default.Children.map(children, function (child) {
      return child.props.read === false;
    }).reduce(function (a, v) {
      return a * 1 + v;
    }, 0);
  }

  return 0;
};

var checkRemovableChildren = function checkRemovableChildren(children) {
  if (children) {
    return _react.default.Children.map(children, function (child) {
      return child.props.removable === true;
    }).reduce(function (a, v) {
      return a * 1 + v;
    }, 0);
  }

  return 0;
};

var NotificationCenter = function NotificationCenter(_ref2) {
  var children = _ref2.children,
      i18n = _ref2.i18n,
      onClearAllClick = _ref2.onClearAllClick,
      onClose = _ref2.onClose,
      onScrollEnd = _ref2.onScrollEnd,
      scrollEndOffset = _ref2.scrollEndOffset,
      unreadCount = _ref2.unreadCount;

  var childrenCount = _react.default.Children.count(children);

  var childrenUnreadCount = countUnreadNotifications(children);
  var childrenRemovableCount = checkRemovableChildren(children);

  var clearAllButton = _react.default.createElement("button", {
    className: "vn-notification-center__clear-all-button",
    onClick: onClearAllClick,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();

      switch (e.key) {
        case ' ':
        case 'Enter':
          e.stopPropagation();
          onClearAllClick();
          break;

        default:
          break;
      }
    },
    type: "button"
  }, i18n.clearAll);

  return _react.default.createElement(_app_bar_panel.default, {
    footer: childrenRemovableCount > 0 ? clearAllButton : undefined,
    onScrollEnd: onScrollEnd,
    onToggleClick: function onToggleClick(open) {
      if (open && childrenUnreadCount > 0) onClose();
    },
    scrollEndOffset: scrollEndOffset,
    panelClassName: "vn-notification-center__panel",
    title: i18n.title,
    toggle: function toggle(onClick, active) {
      return _react.default.createElement(BellButton, {
        active: active,
        onClick: onClick,
        unreadCount: unreadCount || childrenUnreadCount
      });
    }
  }, childrenCount === 0 && _react.default.createElement("div", {
    className: "vn-notification-center__no-notifications"
  }, i18n.noNotifications), childrenCount > 0 && _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      i18n: i18n.timeAgo
    });
  }));
};

NotificationCenter.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf([_notification_center_item.default])
  })), _propTypes.default.shape({
    type: _propTypes.default.oneOf([_notification_center_item.default])
  })]),
  i18n: _propTypes.default.shape({
    clearAll: _propTypes.default.string.isRequired,
    noNotifications: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  }),
  onClearAllClick: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func,
  onScrollEnd: _propTypes.default.func,
  scrollEndOffset: _propTypes.default.number,
  unreadCount: _propTypes.default.number
};
NotificationCenter.defaultProps = {
  children: undefined,
  i18n: {
    clearAll: 'Clear all',
    noNotifications: 'There are no notifications.',
    title: 'Notifications'
  },
  onClose: function onClose() {},
  onScrollEnd: undefined,
  scrollEndOffset: 0,
  unreadCount: undefined
};
NotificationCenter.displayName = 'NotificationCenter';
var _default = NotificationCenter;
exports.default = _default;